import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Threshold } from './threshold';
import { wilkinsonExtended } from '../tick-methods/wilkinson-extended';
import { createQuartile } from '../utils/create-quartile';
/**
 * 类似 Threshold 比例尺，区别在于分位数比例尺 (Quantile) 将一个离散的输入域映射到一个离散的输出域
 * 输入域被指定为一组离散的样本值，输出域中的值的数量决定了分位数的数量。
 */

export var Quantile = /*#__PURE__*/function (_Threshold) {
  _inherits(Quantile, _Threshold);

  var _super = _createSuper(Quantile);

  function Quantile(options) {
    _classCallCheck(this, Quantile);

    return _super.call(this, options);
  }

  _createClass(Quantile, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [],
        range: [],
        tickCount: 5,
        unknown: undefined,
        tickMethod: wilkinsonExtended
      };
    }
  }, {
    key: "rescale",
    value: function rescale() {
      var _this$options = this.options,
          domain = _this$options.domain,
          range = _this$options.range;
      this.n = range.length - 1;
      this.thresholds = createQuartile(domain, this.n + 1, false);
    }
    /**
     * 如果是在第一段后或者最后一段就把两端的值添加上
     */

  }, {
    key: "invert",
    value: function invert(y) {
      var _get$call = _get(_getPrototypeOf(Quantile.prototype), "invert", this).call(this, y),
          _get$call2 = _slicedToArray(_get$call, 2),
          a = _get$call2[0],
          b = _get$call2[1];

      var domain = this.options.domain;
      var dMin = domain[0];
      var dMax = domain[domain.length - 1];
      return a === undefined && b === undefined ? [a, b] : [a || dMin, b || dMax];
    }
  }, {
    key: "getThresholds",
    value: function getThresholds() {
      return this.thresholds;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Quantile(this.options);
    }
  }, {
    key: "getTicks",
    value: function getTicks() {
      var _this$options2 = this.options,
          tickCount = _this$options2.tickCount,
          domain = _this$options2.domain,
          tickMethod = _this$options2.tickMethod;
      var lastIndex = domain.length - 1;
      var min = domain[0];
      var max = domain[lastIndex];
      return tickMethod(min, max, tickCount);
    }
  }]);

  return Quantile;
}(Threshold);